/* eslint-disable quotes */
export default {
  // 中文配置
  app: 'App',
  domain_host_name: '域名（名称）',
  effective_time: '生效时间',
  expiry_time: '有效期',
  application_time: '申请时间',
  last_access_time: '上次访问时间',
  reload: '重新加载',
  online_record: '在线记录',
  domain: '域名',
  white_list: '白名单',
  env_create: '创建环境',
  studio_name: '工作室',
  studio_name_uppercase: '工作室',
  studioid: '工作室编号',
  game_uppercase: '游戏',
  gameid: '游戏ID',
  game_key: '游戏关键字',
  game_name: '游戏名称',
  game_code: '游戏代号',
  user_name: '用户名',
  user_space_type: '用户类型',
  version: '版本',
  zh_news_name: '中文名称',
  en_news_name: '英文名称',
  please_enter_news_name: '请输入通知名称',
  news_range: '范围',
  please_enter_news_range: '选择通知范围',
  content: '内容',
  cnContent: '中文内容',
  enContent: '英文内容',
  need_update: '需要更新',
  title_id: '游戏ID',
  title_name: '游戏名称',
  title_name_lowercase: '游戏名称',
  region_env_name: '地域 (环境名称)',
  studio_name_studio_id: '工作室名称 (工作室编号)',
  env_id: '环境编号',
  env_guid: '环境指引',
  env_name: '环境名称',
  admin_env_type: '类型',
  system: 'System',
  downLoad: '下载物',
  engine: '引擎',
  ioa: 'IOA',
  tag: '标签',
  service_name: '服务名称',
  service_version: '服务版本',
  server_url: 'Server URL',
  gate_address: 'Gate Address',
  realm_url: 'Realm URL',
  objectid: 'Object ID',
  business: '业务',
  type: '数据类型',
  user_type: '用户类型',
  type_uppercase: '下载物类型',
  description: '描述',
  zh_description: '中文描述',
  en_description: '英文描述',
  properties: '属性',
  doc_link: '文件链接',
  doc: '文档链接',
  // g6_type: 'G6',
  // currency_type: 'Currency',
  // gcloud_type: 'GCloud',
  gos: 'Gos',
  support_type: '支持类型',
  // iframe_type: 'Iframe',
  // jump_type: 'Jump',
  // multiplayer_type: 'Multiplayer',
  // social_type: 'Social',
  // economy_type: 'Economy',
  // engage_type: 'Engage',
  // analytics_type: 'Analytics',
  // ue_plugin_type: 'UE Plugin',
  // unity_plugin_type: 'Unity Plugin',
  // cpp_type: 'C++',
  freeze: '冻结',
  online: '在线',

  // download_object_client_type: 'Client',
  // download_object_server_type: 'Server',
  // download_object_sample_type: 'Sample',
  // download_object_tools_type: 'Tools',

  // platform_android_type: 'Android',
  // platform_ios_type: 'iOS',
  // platform_windows_type: 'Windows',
  // platform_mac_type: 'Mac',
  // platform_ps4_type: 'PS4',
  // platform_ps5_type: 'PS5',
  // platform_xsx_type: 'XSX',
  // platform_switch_type: 'Switch',

  ue_version: 'UE版本',
  unity_version: 'Unity版本',
  platforms: '平台',
  ps_sdk_version: 'PS SDK版本',
  gdk_version: 'GDK版本',
  package: '包',

  retry: '重试',
  founder_id: '创建者编号',
  founder_name: '创建者名称',
  parent_sort: '父节点编序',
  parent_name: '父节点名称',
  icon_url: 'IconURL',
  pic: '接口人',
  release_sort: '发布顺序',
  service_path: '服务路径',
  subservice_names: '子服务',
  unique_name: 'UniqueName',
  create_service: '创建服务',
  edit_service: '编辑服务',
  del_service: '删除服务',
  create_download: '创建下载物',
  delete_download: '删除下载',
  edit_download: '编辑下载',
  create_version: '创建版本',
  delete_version: '删除版本',
  edit_version: '编辑版本',
  json_config: 'Json配置',
  config: '配置',
  all_services: '所有服务',
  applicant: '申请人',
  sync_value: '同步值',
  system_type: '系统类型',
  receiver: '接收人',
  default_all: '全部默认',
  please_select_type: '请选择正确的类型!',
  please_select_receiver: '请选择接收人',
  please_select_system_type: '请选择一个系统类型',
  please_input_your_title: '请输入游戏名称!',
  please_input_a_title: '请输入游戏名称',
  password_valid_time: '密码生效期',
  the_field_is_required: '字段{{suffix}}与{{keyTips}}为必填字段',
  the_value_of_field_wrong: '字段 [{{key}}] 的值有误',
  the_field_in_not_expected: '通用配置中的 [{{key}}] 字段不是预期字段',
  copyright_config_error: '权限配置错误',
  game_config_error: '游戏配置错误',
  document_config_error: '文件配置错误',
  legal_terms_config_error: '法律条款配置错误',
  duplicate_configuration_items: '[{{key}}]是重复的配置项',
  is_not_expected_field: '[{{key}}] 不是预期字段',
  create_success: '创建成功',
  create_fail: '创建失败',
  edit_success: '更新成功',
  del_success: '删除成功',
  error_update: '更新失败',
  error_delete: '删除失败',
  json_config_error: 'Json配置错误',
  validate_error: '验证错误',
  del_confirm_h4:
    '您将删除 {{domain}} 配置，且已删除的配置无法恢复！您确定吗？',
  del_confirm_desc_text1:
    '此操作可能会导致数据丢失。为减少不必要的损失，请再次确认您的操作。请输入 ',
  del_confirm_desc_text2: '确认或取消该操作',
  title_warn_select: '请选择一个游戏!',
  studio_warn_select: '请选择一个工作室!',
  region_warn_select: '请选择一个地区!',
  please_input_name: '请输入一个名称!',
  please_enter_name: '请输入一个名称',
  please_enter_version: '请输入一个版本',
  please_enter_download_name: '输入下载物名称',
  please_enter_download_version: '输入下载版本',
  please_select_status: '请选择启用状态!',
  please_select_business: '请选择一个业务!',
  please_select_support_type: '请选择一个支持类型!',
  please_select_parent_name: '请选择一个父节点名称!',
  please_select_one_service: '请选择至少一个服务',
  select_a_parent_name: '选择一个父节点名称',
  please_enter_unique_name: '请输入UniqueName',
  select_studio: '选择一个工作室',
  select_title: '选择一个游戏',
  select_env: '选择一个环境',
  select_region: '选择一个地区',
  env_create_success: '环境创建成功',
  env_create_fail: '环境创建失败',
  notify_success: '通知成功',
  notify_fail: '通知失败',
  select_env_and_service: '选择环境和服务',
  notify_om: '通知 O&M',
  notify: '通知',
  active_time: '生效时间',
  expired_time: '过期时间',
  discard_changes: '放弃更改',
  sure_discard_changes: '您确定要放弃更改吗?',
  please_select_applicant: '请选择申请人!',
  please_enter_password_valid_time: '请选择密码有效期!',
  please_select_download_type: '请选择下载物类型',
  please_select_download_name: '请选择下载物名称',
  please_enter_desc: '输入下载物描述',
  please_enter_zh_desc: '输入下载物中文描述',
  please_enter_en_desc: '输入下载物英文描述',
  please_enter_doc: '输入下载物对应文档地址，例：/doc/detail/35/1001',
  system_list_online: '功能上线',
  system_list_adjust: '功能调整',
  system_list_bug_fix: 'BUG修复',
  system_list_upgrade: '系统升级',
  drop_files_desc: '+ 在此处投放文件或 ',
  browse: '浏览',
  download_list_fail: '查询下载物列表失败。',
  please_select_one_studio: '请选择至少一个工作室',
  update_whitelist_success: '更新白名单成功',
  update_whitelist_fail: '更新白名单失败',
  turn_on: '打开:',
  studio_list: '工作室列表:',
  del_download_sure_desc: '您确定删除下载物吗？: ',
  del_news_sure_desc: '您确定删除信息: ',
  del_version_sure_desc: '您确定删除版本: ',

  email_validation_format:
    "您输入的电子邮件格式似乎不正确。请确保您的电子邮件包含@和域名。例如，'example@example.com'",
  password_short:
    '您的密码太短。为了安全起见，您的密码长度至少应为 14 个字符。请使用更长的密码重试',
  password_not_complexity:
    '您的密码不符合复杂性要求。请至少包含 3 个字母：大写字母、小写字母、数字和符号',
  account_create_success: '账户创建成功',
  account_create_fail: '账户创建失败',
  create_account: '创建账户',
  service_create_success: '创建服务成功!',
  service_create_fail: '创建服务失败!',
  jsonconfig_not_valid: 'Json配置不是有效的 JSON 格式',
  name_format_tips: '只能包含字母、数字、下划线、连字符和空格, 不能全是数字！',
  request_password: '申请密码',
  refresh_status: '刷新状态',
  create_role: '创建角色',
  request_password_success: '申请密码成功!',
  request_password_fail: '申请密码失败!',
  error_same_engine: '不可以选择相同的引擎',
  add_engine: '+ 添加引擎',
  env_list_fetch_fail: '获取环境列表失败',
  number_of_studios: '工作室数量',
  select_or_search_studio: '请选择或搜索工作室',
  number_of_games: '游戏数量',
  select_or_search_game: '请选择或搜索游戏',
  migration: '迁移',
  migration_org_studio: '迁移工作室源',
  select_org_studio: '选择工作室源',
  migration_tar_studio: '迁移目标工作室',
  select_tar_studio: '选择目标工作室',
  migration_org_game: '迁移游戏源',
  select_org_title: '选择游戏源',
  environments_env_length: '环境 ({{envListLength}})',
  migration_success: '迁移成功',
  migration_temporarily_offline: '功能暂时下线',
  migration_fail: '迁移失败',
  fail_uid_of_studio: '查询目标工作室所有者用户的 uid 失败',
  migration_title: '迁移游戏',
  migrate_game_confirm_admin_desc:
    '您确定迁移游戏吗？: 将 {{gameName}} ({{gameId}}) 迁移到: {{studioName}} ({{studioId}})?',
  copy_success: '复制成功',
  copy_password: '复制密码',
  copy: '复制',
  control_account_desc: '管理账户: InGame_Support@tencent.com',
  control_account: '管理账户',
  logout_success: '退出登录成功',
  logout_user: '退出账户',
  logout_user_upper: '退出账户',
  confirm_logout: '确定退出吗?',
  expiry: '有效期',
  refresh_status_success: '刷新状态成功!',
  refresh_status_fail: '刷新状态失败!',
  create_role_success: '创建角色成功!',
  create_role_fail: '创建角色失败!',
  total_search_account_list: '共计: {{count}}',
  total_merge_user_list: '共计: {{mergeUserListLength}}',
  query_fail: '查询失败!',
  sure_close_service_desc: '您确定关闭工作室的服务吗?',
  sure_open_service_desc: '你确定要为工作室开通服务吗?',
  update_service_success: '更新服务成功!',
  update_service_fail: '更新服务失败!',
  modify_service: '更改服务',
  record_copied_to_clipboard: '记录已被复制到剪贴板',
  no_data_available: '无可用数据',
  add_permission_list: '添加权限列表:\n{{userNamesWithDuration}}',
  remove_permission_list: '\n移除权限列表:\n{{userNamesWithNoDuration}}',
  no_list_retry: '目前没有可重试的列表',
  fail_retrieable_list: '未能获得可检索清单',
  retry_success: '重试成功',
  retry_fail: '重试失败',
  retry_to_sync: '重试同步',
  wait_for_retry: '等待重试',
  successful_retry: '重试成功',
  unknown_status: '未知状态',
  please_update_content: '请输入更新的内容',
  please_update_zh_content: '请输入更新的中文内容',
  please_update_en_content: '请输入更新的英文内容',
  content_example: '**内容示例**',
  exceed_character_limit: '字符超过 {{maxLength}} 限制!',
  operation_success: '操作成功!',
  operation_failed_ids: '操作失败 ID(s): {{failedIdsString}}',
  operation_failed: '操作失败',
  confirm_approve: '确定通过?',
  confirm_reject: '确定驳回?',
  confirm_batch_approve: '确定批量通过?',
  confirm_batch_reject: '确定批量驳回?',
  approve: '通过',
  batch_approve: '批量通过',
  reject: '驳回',
  batch_reject: '批量驳回',
  query_status_success_10: '查询用户在线状态成功, 10 秒后重试',
  logout_success_user_id: '({{clickUserID}}) 退出登录成功',
  logout_fail_user_id: '({{clickUserID}}) 退出登录成功',

  // 后台菜单
  support_access: 'Support	权限',
  studio_management: '工作室管理',
  app_config: 'APP 配置',
  service_manage: '服务管理',
  service_online: '上线服务',
  download_manage: '下载管理',
  price_management: '价格管理',
  price_calculator: '价格计算器',
  download_news: '下载中心通知',
  gauth_failed: 'Gauth 失败',
  customer_service: '客户端服务',
  title_manage: '游戏管理',
  game_perm_view: '游戏查看',
  game_perm_edit: '游戏编辑',
  service_application: '服务申请',
  message_push: '消息推送',
  business_notice: '业务通知',
  mail_record: '建联记录',
  upgrade_notification: '升级通知',
  ingame_upgrade_notification: 'InGame升级通知',
  user_manage: '用户管理',
  user_list: '用户列表',
  admin_account: '管理员账户',
  business_account_approve: '业务账号审批',
  game_manage: '游戏管理',
  game_list: '游戏列表',
  platform_operation: '平台运营',
  customer_contact: '业务建联',

  email_push: '邮件推送',
  oa_portal_ad: 'OA门户首页广告位',
  k_m: 'KM',
  wei_bao: '微报',
  qq_tv: '鹅TV',
  gcloud_oa: 'GCloud OA',
  product_presentation: '线下业务宣讲',
  colleague_recommend: '同事推荐',
  others: '其他',

  gcloud_intl: 'GCloud-公众号',
  gcloud_chinese: 'GCloud-中国站',
  social_media: '社交媒体',
  friend_or_colleague_recommend: '朋友推荐',

  intl_gcloud_intl: 'GCloud-Intl',
  twitter: 'Twitter',
  facebook: 'Facebook',
  instagram: 'Instagram',
  youtube: 'Youtube',
  gdc: 'GDC',
  friends: 'Friends',
  intl_others: 'Others',

  mail_name: '用户名',
  mail_email: '邮箱',
  mail_department: '部门',
  mail_company: '公司',
  mail_job_title: '职位',
  mail_status: '发信状态',
  mail_channel: '您是如何得知我们的?',
  mail_application: '申请时间',
  download_record: '下载记录',
  download_obj: '下载物',
  download_status: '下载状态',
  download_link_info: '关联信息',
  download_size: '下载物大小',
  download_time: '下载时间 (UTC)',
  download_time_local: '下载时间',
  user_center: '用户中心',
  website_home: '官网',
  is_sure_copy_record: '确定复制这条记录么?',

  model_name: '计费模式名称',
  price_online_status: '在线状态',
  price_online: '在线',
  price_offline: '离线',
  cost_items: '计费项目',
  cost_script: '计费脚本',
  is_sure_delete_model: '确定删除计费模式:',
  please_enter_model_name: '请输入计费模式名称',
  please_select_cost_items: '请选择计费项目',
  please_enter_cost_script: '请输入计费脚本',
  model_setting: '计费模式设置',

  // 权限中心后台
  group_admin: '资源组',
  object_admin: '资源对象',
  permission_manage: '权限管理',
  permission_list: '权限列表',
  support_permission_list: 'Support 权限列表',
  create_group: 'Create Group',
  batch_create_resources: '批量创建资源',
  batch_create_faild: '批量创建失败，请重试',
  del_group_sure_desc: 'Are you sure you want to delete the Group:',
  object: 'Object',
  create_object: 'Create Object',
  edit_object: 'Edit Object',
  delete_object: 'Delete Object',
  del_object_sure_desc: 'Are you sure you want to delete the Object:',
  parentId: 'Parent Id',
  objectGroupId: 'ObjectGroup Id',
  objectGroupName: 'ObjectGroup Name',
  children: 'Children',
  objects: 'Objects',
  objectKey: 'Object Key',
  objectName: 'Object Name',
  expand_all: '展开所有',
  put_away_all: '收起所有',

  // 企业认证
  menu_company_auth: '企业认证审核',
  company_id: '企业ID',
  company_name: '企业名称',
  company_area: '所属地区',
  company_cooper: '合作伙伴',
  company_auth_applier: '申请人',

  // 费用中心后台
  billing_manage: '计费管理',
  withdrawal_list: '余额提现',

  quit: '退出',
  quit_title: '退出Support',
  quit_body: '确定不再使用Support控制台吗?',
  please_select_new_member: '请输入新成员的企业微信英文名称',

  // 服务批量审批
  service_approval: '服务审批',
  title_code_name: '游戏代号',
  open_service: '开通服务',
  additional_config: '附加配置',
  access_layer_deployment: '接入层部署',
  bianque_deployment: '扁鹊部署',
  report_gateway_deployment: 'ReportGateway部署',
  approval_version: '版本号',
  cannot_batch_approval: '该服务为单独部署流程，暂不支持批量审批',
  pending_status: '待处理',
  processing_status: '开通中',
  resolved_status: '已开通',
  rejected_status: '已驳回',
  admin_apply_service: '申请服务',
  admin_region: '部署环境',
  admin_studio_info: '工作室信息',
  admin_applicant: '申请人',
  admin_applicant_time: '申请时间',
  admin_modify_time: '最近变更时间',
  admin_approver: '审批人',
  admin_result: '处理状态',
};
